import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "bottom-0 absolute px-6 pr-10 py-6 bg-white w-full"
};
const _hoisted_2 = {
  class: ""
};
const _hoisted_3 = {
  class: "flex justify-start space-x-2"
};
const _hoisted_4 = {
  class: "flex space-x-2"
};
const _hoisted_5 = {
  class: "flex justify-between no-print"
};
const _hoisted_6 = {
  class: "flex justify-start space-x-2"
};
const _hoisted_7 = {
  class: "flex justify-end space-x-2"
};
const _hoisted_8 = {
  class: "flex justify-between no-print"
};
const _hoisted_9 = {
  class: "flex justify-start space-x-2"
};
const _hoisted_10 = {
  class: "flex justify-end space-x-2"
};
const _hoisted_11 = {
  class: "no-print flex justify-start space-x-2"
};
const _hoisted_12 = {
  class: "no-print"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import LlListConfirmationDialog from '@/components/LlListConfirmationDialog.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import AlertBar from '@/components/AlertBar.vue';
import UpdateInvoiceTemplateModal from '@/modules/settings/company/InvoiceEmail/InvoicePdf/InvoiceTemplate/UpdateInvoiceTemplateModal.vue';
import EventTracker from '@/services/eventTracker';
import DownloadService from '@/services/DownloadService';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { useInvoiceTemplateStore } from '@/services/useInvoiceTemplateStore.js';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { usePlanSelection } from '@/composables/usePlanSelection';
import { storeToRefs } from 'pinia';
import { onMounted, reactive, ref, computed } from 'vue';
export default {
  __name: 'InvoiceButtons',
  props: {
    leanLawAuth: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: false
    },
    rootScope: {
      type: Object,
      required: true
    }
  },
  emits: ['rejectInvoice', 'undo', 'cancel', 'openSubscriptionModal'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const invoiceState = useInvoiceState();
    const companyStore = useCompanyStore();
    const invoiceTemplateStore = useInvoiceTemplateStore();
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    const {
      openPlanSelection
    } = usePlanSelection();
    const invoiceEditorStore = useInvoiceEditorStore();
    const meStore = useMeStore();
    const {
      updateMe
    } = meStore;
    const {
      features,
      permissions,
      settings
    } = storeToRefs(meStore);
    const {
      companySettings
    } = storeToRefs(companyStore);
    const {
      isSaving,
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      groups,
      totals,
      state,
      access,
      id,
      detail,
      accounting,
      client,
      isSplitBilling
    } = invoiceState;
    const zeroRateAlert = ref(undefined);
    const quickbookSubmissionConfirmation = ref(undefined);
    const splitBillingConfirmDialog = ref(undefined);
    const splitBillingInvoiceList = ref([]);
    const showInvoiceTemplateModal = ref(false);
    const selectedTemplateId = ref(null);
    const isLoadingDemoTemplate = ref(false);

    // Computed property for dynamic message with count
    const splitBillingMessage = computed(() => {
      const count = splitBillingInvoiceList.value.length;
      if (count === 0) {
        return 'The following invoices will be removed from QuickBooks and moved back to the draft folder:';
      } else {
        return `The following ${count} invoices will be removed from QuickBooks and moved back to the draft folder:`;
      }
    });
    const canUndoInvoice = () => state.draft;
    const canRecallInvoice = () => state.open || state.approved || state.closed && totals.billedAmount === 0;
    const accessItem = computed(() => {
      const draft = state.draft || companySettings.value.workflow.invoiceDraft;
      const submitted = !(draft || state.approved);
      const approve = access.approve && companySettings.value.workflow.invoiceApprove;
      const quickbooks = true;
      const orphan = invoiceState.isOrphanBilled;
      return {
        undo: access.undo && canUndoInvoice(),
        recall: canRecallInvoice(),
        edit: access.edit && draft && !orphan,
        approve: approve && draft,
        review: companySettings.value.workflow.invoiceReview,
        approveSubmit: approve && quickbooks && draft && !orphan,
        approveSubmitSend: approve && quickbooks && draft && !orphan,
        submit: quickbooks && !submitted && !(approve && draft) && !orphan,
        submitSend: quickbooks && !submitted && !(approve && draft) && !orphan,
        send: quickbooks && submitted && !state.deleted && !orphan,
        view: quickbooks && submitted && !state.deleted
      };
    });
    const confirmDialog = ref(null);
    const autoAdvanceEnabled = ref(settings.value.autoAdvanceDraft ?? false);
    const conformationState = reactive({
      title: '',
      confirmText: '',
      rejectText: '',
      confirmationDialogContent: '',
      isHtml: false
    });
    onMounted(async () => {
      autoAdvanceEnabled.value = settings.value.autoAdvanceDraft ?? false;
    });
    const buttonsState = reactive({
      printing: false,
      savingOnly: false,
      reviewAndApprove: false,
      showZeroRateConfirmationModal: false,
      saveWithZeroRate: false,
      showQuickbookSubmissionConfirmation: false,
      confirmQuickbookSubmission: false
    });
    const buildSplitBillingConfirmationMessage = (associatedInvoices, selectedInvoices) => {
      const isPreviewAvailable = associatedInvoices !== null;
      const invoicesToShow = isPreviewAvailable ? associatedInvoices : selectedInvoices;
      const count = invoicesToShow.length;
      const listHeader = `The following ${count} invoice(s) will be removed from QuickBooks and moved back to the draft folder: <br/>`;
      const invoiceList = invoicesToShow.map((invoice, index) => `${index + 1}. Invoice ${invoice.reference || 'No Reference'}`).join('<br/>');
      return listHeader + invoiceList;
    };
    const triggerRecallSplitInvoiceConfirmation = async () => {
      const invoice = invoiceState;
      const invoiceId = invoice.id;
      const associatedInvoices = await invoiceEditorStore.fetchAssociatedSplitBillingInvoices({
        id: invoiceId
      });

      // Transform the invoices into a list format for the new dialog
      const invoiceList = associatedInvoices?.map((invoice, index) => ({
        title: `Invoice ${invoice.reference || 'No Reference'}`
      })) || [];
      // Set the reactive list that's bound to the component
      splitBillingInvoiceList.value = invoiceList;
      splitBillingConfirmDialog.value.open().then(result => {
        if (result) {
          return invoiceEditorStore.recallInvoice({
            id: invoiceId
          }).then(() => {
            handleSuccess('Invoice was removed from QuickBooks and moved to drafts');
            emit('cancel', true);
          }).catch(err => {
            handleError(err);
          }).finally(() => {
            // Clear the list after dialog closes
            splitBillingInvoiceList.value = [];
          });
        } else {
          // Clear the list if canceled
          splitBillingInvoiceList.value = [];
        }
      });
    };
    const triggerDeleteInvoiceWithoutGroupConfirmation = () => {
      setConfirmationState('There are no line items', `You cannot save an empty invoice. You may either remove
                    the invoice or undo your changes.`, 'Delete invoice', 'Go back');
      confirmDialog.value.open().then(result => {
        if (result) {
          // First save the invoice, then delete
          const invoice = invoiceState;
          invoice.invoiceState = state.state;
          invoiceEditorStore.updateInvoice({
            id: invoice.id,
            data: invoice
          }).then(() => {
            // After saving, proceed with deletion
            return invoiceEditorStore.deleteInvoice({
              id: invoiceState.id
            });
          }).then(() => {
            handleSuccess('Invoice has been successfully deleted.');
            emit('cancel', true);
            if (settings.value.autoAdvanceDraft) props.rootScope.selectNextInvoice();
          }).catch(err => {
            handleError(err);
          });
        } else {
          buttonsState.deleteInvoiceWithoutGroupConfirmation = false;
          buttonsState.confirmQuickbookSubmission = false;
          buttonsState.saveWithZeroRate = false;
          buttonsState.reviewAndApprove = false;
        }
      });
    };
    const triggerZeroRateConfirmation = finalConfirmation => {
      buttonsState.showZeroRateConfirmationModal = true;
      zeroRateAlert.value.open().then(result => {
        if (result) {
          buttonsState.showZeroRateConfirmationModal = false;
          buttonsState.saveWithZeroRate = true;
          finalConfirmation && confirm(null, true);
        } else {
          buttonsState.showZeroRateConfirmationModal = false;
          buttonsState.showQuickbookSubmissionConfirmation = false;
          buttonsState.confirmQuickbookSubmission = false;
        }
      });
    };
    const triggerQuickBookSubmissionConfirmation = () => {
      buttonsState.showQuickbookSubmissionConfirmation = true;
      quickbookSubmissionConfirmation.value.open().then(result => {
        if (result) {
          buttonsState.showQuickbookSubmissionConfirmation = false;
          buttonsState.confirmQuickbookSubmission = true;
          confirm({
            submit: true
          }, false);
        } else {
          buttonsState.showQuickbookSubmissionConfirmation = false;
          buttonsState.confirmQuickbookSubmission = false;
          buttonsState.saveWithZeroRate = false;
          buttonsState.reviewAndApprove = false;
        }
      });
    };
    const rejectInvoice = () => {
      emit('rejectInvoice');
    };
    const updateAutoAdvance = () => {
      updateMe({
        settings: {
          ...settings.value,
          autoAdvanceDraft: autoAdvanceEnabled.value
        }
      });
    };

    // Demo mode function to open invoice template modal
    const openInvoiceTemplate = async () => {
      // Set loading state
      isLoadingDemoTemplate.value = true;
      try {
        // First, save any draft changes before opening the template modal
        const invoice = invoiceState;
        invoice.invoiceState = state.state;
        await invoiceEditorStore.updateInvoice({
          id: invoice.id,
          data: invoice
        });

        // Then fetch the list of invoice templates
        const templates = await invoiceTemplateStore.getTemplates();
        if (templates && templates.length > 0) {
          // Find the default template, or use the first one if no default is found
          const defaultTemplate = templates.find(template => template.default === true) || templates[0];

          // Set the selected template ID
          selectedTemplateId.value = defaultTemplate.invoiceTemplateId;

          // Track Invoice Template Opened from demo mode
          if (props.tracking) {
            EventTracker.trackEvent(props.tracking, 'Invoice Template', 'Opened', {
              templateId: defaultTemplate.invoiceTemplateId,
              sourceContext: 'trainingFlow'
            });
          }

          // Open the modal with the selected template
          showInvoiceTemplateModal.value = true;
        } else {
          // No templates found, show error or open modal without a template
          handleError('No invoice templates found');
          showInvoiceTemplateModal.value = true;
        }
      } catch (error) {
        handleError('Failed to save draft or load invoice templates');
        // Still open the modal for fallback
        showInvoiceTemplateModal.value = true;
      } finally {
        // Clear loading state when modal is opened (or on error)
        isLoadingDemoTemplate.value = false;
      }
    };

    // Handle opening the invoice template modal
    const handleCloseInvoiceTemplate = shouldReload => {
      showInvoiceTemplateModal.value = false;
      selectedTemplateId.value = null; // Reset the selected template
      isLoadingDemoTemplate.value = false; // Ensure loading state is cleared
      if (shouldReload) {
        // Handle any reload logic here if needed
      }
    };

    // Handle opening the subscription modal (plan selection)
    const handleOpenSubscriptionModal = () => {
      // Close the invoice template modal first
      showInvoiceTemplateModal.value = false;
      selectedTemplateId.value = null;

      // Emit event to parent to handle modal closure and navigation
      emit('openSubscriptionModal');
    };

    // Handle closing the draft modal when subscription CTA is clicked
    const handleCloseDraftModal = () => {
      // Close the invoice template modal first
      showInvoiceTemplateModal.value = false;
      selectedTemplateId.value = null;

      // Open plan selection modal
      openPlanSelection();

      // Tell the main draft modal to close itself (which will navigate to /billing/draft)
      emit('cancel', true);
    };
    const downloadService = new DownloadService(props.leanLawAuth);

    // The endpoint answers with Content-Disposition: attachment, so pointing the browser
    // at it starts a download and leaves the page exactly where it is -- no tab involved.
    // Opening a tab for it, as this used to, relies on Chrome discarding a tab whose first
    // navigation turns out to be a download, which it only does for a tab that has not
    // committed a document yet. Same approach as ledes() and viewDetail() below.
    //
    // The PDF is rendered server-side from the saved invoice, so this always reflects the
    // last save. Users who cannot edit see this on its own; users who can get Save & Print
    // instead, which commits first so the PDF matches what is on screen.
    const printInvoice = () => {
      downloadService.get(`/v1/invoices/pdf?invoices=${id}&download=true`);
    };

    // Printing a draft is nearly always to show a client or to file a copy, so the PDF
    // needs to reflect what the user is looking at rather than the last save. Saving
    // first is what makes that true -- the print endpoint renders TimeSheet.InvoiceDataJson.
    //
    // Runs the same two gates Save does, for the same reasons: an empty invoice cannot be
    // saved, and $0 rates become $0 time entries once committed. Unlike Save it does not
    // close the modal or auto-advance -- the user asked to print, not to move on.
    const saveAndPrint = async () => {
      // Vuetify's `loading` does not disable a v-btn -- it only sets aria-busy and drops
      // it out of the tab order. Without this guard a double-click fires two concurrent
      // PUTs, and that save moves entries and charges between invoices.
      if (buttonsState.printing) return;
      const hasNoGroupsOrLineItems = invoiceState.groups.length === 0 || invoiceState.groups.every(group => !group.lineItems || group.lineItems.length === 0);
      if (hasNoGroupsOrLineItems) {
        triggerDeleteInvoiceWithoutGroupConfirmation();
        return;
      }
      if (detectZeroRateEntries(groups).length > 0) {
        buttonsState.showZeroRateConfirmationModal = true;
        const proceed = await zeroRateAlert.value.open();
        buttonsState.showZeroRateConfirmationModal = false;
        if (!proceed) return;
      }
      buttonsState.printing = true;
      try {
        const invoice = invoiceState;
        invoice.invoiceState = state.state;
        const saved = await invoiceEditorStore.updateInvoice({
          id: invoice.id,
          data: invoice
        });

        // updateInvoice reports its own failures and resolves undefined rather than
        // rejecting. Without this check a failed save falls straight through and prints
        // the stale stored PDF, which is the exact bug this button exists to fix.
        if (!saved) return;

        // Starting the download is a navigation, not a popup, so it is unaffected by the
        // await above -- no need to reserve anything before the save.
        printInvoice();
      } catch (err) {
        handleError(err);
      } finally {
        buttonsState.printing = false;
      }
    };
    const detectZeroRateEntries = groups => {
      const zeroRateEntries = [];
      groups.forEach(group => {
        group.lineItems?.forEach(lineItem => {
          lineItem.entries?.forEach(entry => {
            if (entry?.billingType == 'billable' && entry.rate?.amount == 0) {
              zeroRateEntries.push({
                groupName: group.name,
                lineItemDescription: lineItem.description,
                entryDescription: entry.description,
                entryId: entry.id,
                rate: entry.rate.amount
              });
            }
          });
        });
      });
      return zeroRateEntries;
    };
    const confirm = async (actions, saveOnly) => {
      const zeroRateEntries = detectZeroRateEntries(groups);
      const invoice = invoiceState;

      // Drain the queue so a second save doesn't re-emit these
      const events = invoice.eventsToTrack.splice(0);
      if (props.tracking) {
        events.forEach(e => {
          props.tracking.event(e.category, e.action, {
            ...e.properties,
            timeSheetId: invoice.id
          });
        });
      }
      const hasNoGroupsOrLineItems = invoiceState.groups.length === 0 || invoiceState.groups.every(group => !group.lineItems || group.lineItems.length === 0);
      if (hasNoGroupsOrLineItems) {
        triggerDeleteInvoiceWithoutGroupConfirmation();
        return;
      }
      if (saveOnly) {
        if (zeroRateEntries.length > 0 && !buttonsState.saveWithZeroRate) {
          triggerZeroRateConfirmation(true); // Show Zero Rate dialog
          return;
        } else {
          invoice.invoiceState = state.state;
          buttonsState.savingOnly = true;
          return invoiceEditorStore.updateInvoice({
            id: invoice.id,
            data: invoice
          }).then(() => {
            buttonsState.savingOnly = false;
            emit('cancel', true);
            if (settings.value.autoAdvanceDraft) props.rootScope.selectNextInvoice();
          }).catch(err => {
            buttonsState.savingOnly = false;
            handleError(err);
          });
        }
      }
      buttonsState.reviewAndApprove = true;
      try {
        if (actions.review || actions.approve) {
          if (hasNoGroupsOrLineItems) {
            buttonsState.reviewAndApprove = false;
            triggerDeleteInvoiceWithoutGroupConfirmation();
            return;
          }
          invoice.invoiceState = actions.review ? 'review' : 'approved';
          await invoiceEditorStore.updateInvoice({
            id: invoice.id,
            data: invoice
          });
          emit('cancel', true);
          if (settings.value.autoAdvanceDraft) props.rootScope.selectNextInvoice();
          buttonsState.reviewAndApprove = true;
        } else if (actions.submit && !buttonsState.confirmQuickbookSubmission) {
          // Handle the submit case
          if (zeroRateEntries.length > 0 && !buttonsState.saveWithZeroRate) {
            buttonsState.reviewAndApprove = false;
            // Trigger QuickBook confirmation first
            triggerQuickBookSubmissionConfirmation();
            triggerZeroRateConfirmation(false);
          } else {
            triggerQuickBookSubmissionConfirmation();
          }
        } else {
          if (hasNoGroupsOrLineItems) {
            buttonsState.reviewAndApprove = false;
            triggerDeleteInvoiceWithoutGroupConfirmation();
            return;
          }
          await invoiceEditorStore.updateInvoice({
            id: invoice.id,
            data: invoice
          });
          return props.leanLawApi.processInvoice({
            id: invoice.id,
            body: actions
          }).then(() => {
            handleSuccess('Invoice has been successfully submitted to QuickBooks');
            buttonsState.reviewAndApprove = false;
            emit('cancel', true);
            if (settings.value.autoAdvanceDraft) props.rootScope.selectNextInvoice();
          }).catch(err => {
            buttonsState.reviewAndApprove = false;
            handleError(err.body.message);
            buttonsState.saveWithZeroRate = false;
            buttonsState.confirmQuickbookSubmission = false;
          });
        }
      } catch (err) {
        buttonsState.reviewAndApprove = false;
        handleError(err);
      }
    };
    const ledes = () => {
      window.location.href = `${props.leanLawAuth.domain}/v1/invoices/${id}/ledes?download=true`;
    };
    const viewDetail = () => {
      window.location.href = `${props.leanLawAuth.domain}/v1/invoices/${id}/detail?download=true`;
    };
    const setConfirmationState = (title, body, confirmText, rejectText = 'Cancel', isHtml = false) => {
      conformationState.title = title;
      conformationState.body = body;
      conformationState.confirmText = confirmText;
      conformationState.rejectText = rejectText;
      conformationState.isHtml = isHtml;
    };
    const undo = (isOpen, isApproved, isStateChange) => {
      if (isOpen) {
        setConfirmationState('Undo Invoice', `Undoing this invoice will remove it from QuickBooks
      and release its entries and expenses. The invoice will be deleted
      from LeanLaw. You may then create a new invoice at a later time
      containing the same entries and/or expenses. Continue?`, 'Undo Invoice');
      } else if (isStateChange) {
        setConfirmationState('Revert Invoice', `This invoice will be reverted to ${state.state === 'Approved' ? 'review' : 'draft'} stage where it may
      be ${state.state === 'Approved' ? 're-reviewed' : 're-approved'}. This does not delete the invoice. Continue?`, 'Revert Invoice');
      } else if (isApproved) {
        setConfirmationState('Revert Invoice', `This invoice will be reverted to draft stage where it may
      be re-approved. This does not delete the invoice. Continue?`, 'Revert Invoice');
      } else {
        setConfirmationState('Undo Draft', `Undoing this invoice will release its entries and expenses
      and remove it from LeanLaw. You may then create a new invoice at a
      later time containing the same entries and/or expenses. Continue?`, 'Remove Invoice');
      }
      confirmDialog.value.open().then(async result => {
        if (result) {
          try {
            if (isApproved) {
              await invoiceEditorStore.recallInvoice({
                id
              });
            } else if (isStateChange) {
              await invoiceEditorStore.updateInvoice({
                id,
                data: {
                  invoiceState: state.state === 'Approved' ? 'review' : 'draft'
                }
              });
            } else {
              await invoiceEditorStore.deleteInvoice({
                id
              });
            }
            emit('cancel', true);
          } catch (err) {
            handleError(err);
          }
        }
      });
    };
    const recall = () => {
      if (isSplitBilling) {
        triggerRecallSplitInvoiceConfirmation();
        return;
      }
      setConfirmationState('Back to draft', `This invoice will be removed from QuickBooks and
    returned to LeanLaw as a draft. It can then be edited and re-approved. Continue?`, 'Back to draft');
      confirmDialog.value.open().then(result => {
        if (result) {
          return invoiceEditorStore.recallInvoice({
            id
          }).then(() => {
            handleSuccess('Invoice was removed from QuickBooks and moved to drafts');
            emit('cancel', true);
          }).catch(err => {
            handleError(err);
          });
        }
      });
    };
    const emit = __emit;
    const isLedesInvoice = () => {
      return client?.codes?.ledes || false;
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(invoiceState).isOrphanBilled ? (_openBlock(), _createBlock(AlertBar, {
        key: 0,
        class: "mb-3",
        "data-cy": "orphan-billed-banner",
        content: "This invoice is no longer linked to QuickBooks. It may have been deleted in QuickBooks or the connection was changed. Some actions are restricted."
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(LlConfirmationDialog, {
        ref_key: "confirmDialog",
        ref: confirmDialog,
        title: conformationState.title,
        "confirm-text": conformationState.confirmText,
        "toggle-text": conformationState.rejectText,
        message: conformationState.body
      }, null, 8, ["title", "confirm-text", "toggle-text", "message"]), _createVNode(LlConfirmationDialog, {
        showWarningIcon: true,
        ref_key: "quickbookSubmissionConfirmation",
        ref: quickbookSubmissionConfirmation,
        title: 'Confirm Action',
        message: 'Submit one invoice to QuickBooks?',
        "confirm-text": 'OK',
        "toggle-text": 'Cancel'
      }, null, 512), _createVNode(LlConfirmationDialog, {
        showWarningIcon: true,
        ref_key: "zeroRateAlert",
        ref: zeroRateAlert,
        title: "",
        "confirm-text": "Save Anyway",
        "toggle-text": "Cancel",
        message: `Note: One or more of the entries in this draft invoice have a $0 rate defined. If you continue, this will result in time entries with $0 rates.`
      }, null, 512), _createVNode(LlListConfirmationDialog, {
        ref_key: "splitBillingConfirmDialog",
        ref: splitBillingConfirmDialog,
        showWarningIcon: true,
        title: "Recall Split Invoice",
        message: splitBillingMessage.value,
        "confirm-text": "Back to draft",
        "toggle-text": "Cancel",
        "list-items": splitBillingInvoiceList.value
      }, null, 8, ["message", "list-items"]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["flex justify-between no-print", {
          pending: _unref(isSaving)
        }])
      }, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(LlSecondaryButton, {
        "data-cy": "cancel-draft",
        onBtnClick: _cache[0] || (_cache[0] = $event => rejectInvoice())
      }, {
        default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(permissions).billing.edit && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[1] || (_cache[1] = $event => rejectInvoice()),
        "data-cy": "close-draft"
      }, {
        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode(" Close ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !_unref(permissions).billing.edit || _unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        "data-cy": "undo-draft",
        onBtnClick: _cache[2] || (_cache[2] = $event => undo())
      }, {
        default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode(" Undo draft ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.undo && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        loading: buttonsState.printing,
        disabled: buttonsState.printing,
        "data-cy": "save-and-print-invoice",
        onBtnClick: _cache[3] || (_cache[3] = $event => saveAndPrint())
      }, {
        default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createTextVNode(" Save & Print ", -1)]))]),
        _: 1
      }, 8, ["loading", "disabled"]), [[_vShow, _unref(permissions).billing.edit && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        "data-cy": "print-invoice",
        onBtnClick: _cache[4] || (_cache[4] = $event => printInvoice())
      }, {
        default: _withCtx(() => [...(_cache[51] || (_cache[51] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !_unref(permissions).billing.edit || _unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[5] || (_cache[5] = $event => ledes()),
        disabled: _unref(invoiceState).getHasInvoiceChanged || _unref(isSplitBilling),
        "data-cy": "ledes-download"
      }, {
        default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode(" LEDES ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), [[_vShow, isLedesInvoice()]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[6] || (_cache[6] = $event => viewDetail())
      }, {
        default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode(" Detail ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(detail)]])]), _createElementVNode("div", _hoisted_4, [_createVNode(LlCheckbox, {
        modelValue: autoAdvanceEnabled.value,
        "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => autoAdvanceEnabled.value = $event), _cache[8] || (_cache[8] = $event => updateAutoAdvance())],
        label: "Auto-Advance",
        labelClass: "text-sm mt-1",
        info: "Automatically open the next invoice after saving or submitting the current one"
      }, null, 8, ["modelValue"]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[9] || (_cache[9] = $event => confirm(null, true)),
        isSaving: buttonsState.savingOnly,
        "data-cy": "save-draft"
      }, {
        default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      }, 8, ["isSaving"]), [[_vShow, (_unref(state).draft || _unref(access).edit) && _unref(permissions).billing.edit && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[10] || (_cache[10] = $event => confirm({
          review: true
        }, false)),
        isSaving: buttonsState.reviewAndApprove
      }, {
        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [_createTextVNode(" Review ", -1)]))]),
        _: 1
      }, 8, ["isSaving"]), [[_vShow, (_unref(state).draft || accessItem.value.edit) && _unref(companySettings).workflow.invoiceApprove && accessItem.value.review && _unref(permissions).billing.approve && !_unref(companySettings).demoMode]]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[11] || (_cache[11] = $event => confirm({
          approve: true
        }, false)),
        isSaving: buttonsState.reviewAndApprove
      }, {
        default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode(" Approve ", -1)]))]),
        _: 1
      }, 8, ["isSaving"]), [[_vShow, (_unref(state).draft || accessItem.value.edit) && _unref(companySettings).workflow.invoiceApprove && !accessItem.value.review && _unref(permissions).billing.approve && !_unref(companySettings).demoMode]]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[12] || (_cache[12] = $event => confirm({
          submit: true
        }, false)),
        isSaving: buttonsState.reviewAndApprove
      }, {
        default: _withCtx(() => [...(_cache[57] || (_cache[57] = [_createTextVNode(" Approve & Submit ", -1)]))]),
        _: 1
      }, 8, ["isSaving"]), [[_vShow, (_unref(state).draft || accessItem.value.edit) && !_unref(companySettings).workflow.invoiceApprove && _unref(permissions).billing.submit && _unref(permissions).billing.approve && !_unref(companySettings).demoMode]]), _unref(companySettings).demoMode && _unref(features).invoicingDemoMode ? (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 0,
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[13] || (_cache[13] = $event => openInvoiceTemplate()),
        isSaving: isLoadingDemoTemplate.value,
        disabled: isLoadingDemoTemplate.value,
        "data-cy": "continue-demo-draft"
      }, {
        default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode(" Continue ", -1)]))]),
        _: 1
      }, 8, ["isSaving", "disabled"])) : _createCommentVNode("", true)])], 2), [[_vShow, _unref(state).draft]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[14] || (_cache[14] = $event => rejectInvoice())
      }, {
        default: _withCtx(() => [...(_cache[59] || (_cache[59] = [_createTextVNode(" Close ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !_unref(permissions).billing.edit || _unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[15] || (_cache[15] = $event => rejectInvoice())
      }, {
        default: _withCtx(() => [...(_cache[60] || (_cache[60] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(permissions).billing.edit && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[16] || (_cache[16] = $event => undo(false, false, true))
      }, {
        default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode(" Back to draft ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(permissions).billing.approve]]), _withDirectives(_createVNode(LlSecondaryButton, {
        loading: buttonsState.printing,
        disabled: buttonsState.printing,
        "data-cy": "save-and-print-invoice",
        onBtnClick: _cache[17] || (_cache[17] = $event => saveAndPrint())
      }, {
        default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode(" Save & Print ", -1)]))]),
        _: 1
      }, 8, ["loading", "disabled"]), [[_vShow, _unref(permissions).billing.edit && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        "data-cy": "print-invoice",
        onBtnClick: _cache[18] || (_cache[18] = $event => printInvoice())
      }, {
        default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }, 512), [[_vShow, !_unref(permissions).billing.edit || _unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[19] || (_cache[19] = $event => ledes()),
        disabled: _unref(invoiceState).getHasInvoiceChanged || _unref(isSplitBilling),
        "data-cy": "ledes-download"
      }, {
        default: _withCtx(() => [...(_cache[64] || (_cache[64] = [_createTextVNode(" LEDES ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), [[_vShow, isLedesInvoice()]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[20] || (_cache[20] = $event => viewDetail())
      }, {
        default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode(" Detail ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(detail)]])]), _createElementVNode("div", _hoisted_7, [_createVNode(LlCheckbox, {
        modelValue: autoAdvanceEnabled.value,
        "onUpdate:modelValue": [_cache[21] || (_cache[21] = $event => autoAdvanceEnabled.value = $event), _cache[22] || (_cache[22] = $event => updateAutoAdvance())],
        label: "Auto-Advance",
        labelClass: "text-sm mt-1",
        info: "Automatically open the next invoice after saving or submitting the current one"
      }, null, 8, ["modelValue"]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[23] || (_cache[23] = $event => confirm(null, true)),
        isSaving: buttonsState.savingOnly,
        disabled: buttonsState.savingOnly
      }, {
        default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      }, 8, ["isSaving", "disabled"]), [[_vShow, _unref(permissions).billing.edit && !_unref(onlyViewInvoice)]]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[24] || (_cache[24] = $event => confirm({
          approve: true
        }, false)),
        isSaving: buttonsState.reviewAndApprove,
        disabled: buttonsState.reviewAndApprove
      }, {
        default: _withCtx(() => [...(_cache[67] || (_cache[67] = [_createTextVNode(" Approve ", -1)]))]),
        _: 1
      }, 8, ["isSaving", "disabled"]), [[_vShow, _unref(permissions).billing.approve]])])], 512), [[_vShow, _unref(state).review]]), _withDirectives(_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[25] || (_cache[25] = $event => rejectInvoice())
      }, {
        default: _withCtx(() => [...(_cache[68] || (_cache[68] = [_createTextVNode(" Close ", -1)]))]),
        _: 1
      }), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[26] || (_cache[26] = $event => undo(false, false, true))
      }, {
        default: _withCtx(() => [...(_cache[69] || (_cache[69] = [_createTextVNode(" Back to Review ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(permissions).billing.approve && accessItem.value.review]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[27] || (_cache[27] = $event => undo(false, true))
      }, {
        default: _withCtx(() => [...(_cache[70] || (_cache[70] = [_createTextVNode(" Back to draft ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.undo && _unref(permissions).billing.approve && !accessItem.value.review]]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[28] || (_cache[28] = $event => printInvoice())
      }, {
        default: _withCtx(() => [...(_cache[71] || (_cache[71] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[29] || (_cache[29] = $event => ledes()),
        disabled: _unref(invoiceState).getHasInvoiceChanged || _unref(isSplitBilling),
        "data-cy": "ledes-download"
      }, {
        default: _withCtx(() => [...(_cache[72] || (_cache[72] = [_createTextVNode(" LEDES ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), [[_vShow, isLedesInvoice()]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[30] || (_cache[30] = $event => viewDetail())
      }, {
        default: _withCtx(() => [...(_cache[73] || (_cache[73] = [_createTextVNode(" Detail ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(detail)]])]), _createElementVNode("div", _hoisted_10, [_createVNode(LlCheckbox, {
        modelValue: autoAdvanceEnabled.value,
        "onUpdate:modelValue": [_cache[31] || (_cache[31] = $event => autoAdvanceEnabled.value = $event), _cache[32] || (_cache[32] = $event => updateAutoAdvance())],
        label: "Auto-Advance",
        labelClass: "text-sm mt-1",
        info: "Automatically open the next invoice after saving or submitting the current one"
      }, null, 8, ["modelValue"]), _withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[33] || (_cache[33] = $event => confirm({
          submit: true
        }, false)),
        isSaving: buttonsState.reviewAndApprove,
        disabled: buttonsState.reviewAndApprove
      }, {
        default: _withCtx(() => [...(_cache[74] || (_cache[74] = [_createTextVNode(" Approve & Submit ", -1)]))]),
        _: 1
      }, 8, ["isSaving", "disabled"]), [[_vShow, _unref(permissions).billing.submit]])])], 512), [[_vShow, _unref(state).approved]]), _withDirectives(_createElementVNode("div", _hoisted_11, [_withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[34] || (_cache[34] = $event => _ctx.viewInQb())
      }, {
        default: _withCtx(() => [...(_cache[75] || (_cache[75] = [_createTextVNode(" Open in QuickBooks ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(accounting) && accessItem.value.view]]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[35] || (_cache[35] = $event => rejectInvoice()),
        "data-cy": "close-invoice"
      }, {
        default: _withCtx(() => [...(_cache[76] || (_cache[76] = [_createTextVNode(" Close ", -1)]))]),
        _: 1
      }), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[36] || (_cache[36] = $event => recall())
      }, {
        default: _withCtx(() => [...(_cache[77] || (_cache[77] = [_createTextVNode(" Back to Draft ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.recall && _unref(permissions).billing.submit]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[37] || (_cache[37] = $event => undo(true))
      }, {
        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [_createTextVNode(" Undo ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.undo && _unref(permissions).billing.create]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[38] || (_cache[38] = $event => printInvoice())
      }, {
        default: _withCtx(() => [...(_cache[79] || (_cache[79] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.recall && _unref(permissions).billing.create]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[39] || (_cache[39] = $event => ledes()),
        disabled: _unref(invoiceState).getHasInvoiceChanged || _unref(isSplitBilling),
        "data-cy": "ledes-download"
      }, {
        default: _withCtx(() => [...(_cache[80] || (_cache[80] = [_createTextVNode(" LEDES ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), [[_vShow, isLedesInvoice()]]), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[40] || (_cache[40] = $event => viewDetail())
      }, {
        default: _withCtx(() => [...(_cache[81] || (_cache[81] = [_createTextVNode(" Detail ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(detail)]]), _cache[82] || (_cache[82] = _createElementVNode("div", {
        class: "clear"
      }, null, -1))], 512), [[_vShow, _unref(state).open]]), _withDirectives(_createElementVNode("div", _hoisted_12, [_withDirectives(_createVNode(LlSecondaryButton, {
        variant: "flat",
        color: "primary",
        onBtnClick: _cache[41] || (_cache[41] = $event => _ctx.viewInQb())
      }, {
        default: _withCtx(() => [...(_cache[83] || (_cache[83] = [_createTextVNode(" Open in QuickBooks ", -1)]))]),
        _: 1
      }, 512), [[_vShow, _unref(accounting) && accessItem.value.view]]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[42] || (_cache[42] = $event => rejectInvoice())
      }, {
        default: _withCtx(() => [...(_cache[84] || (_cache[84] = [_createTextVNode(" Close ", -1)]))]),
        _: 1
      }), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[43] || (_cache[43] = $event => recall())
      }, {
        default: _withCtx(() => [...(_cache[85] || (_cache[85] = [_createTextVNode(" Back to Draft ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.undo && _unref(totals).amount == 0 && _unref(permissions).billing.submit]]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[44] || (_cache[44] = $event => printInvoice())
      }, {
        default: _withCtx(() => [...(_cache[86] || (_cache[86] = [_createTextVNode(" Print ", -1)]))]),
        _: 1
      }), _withDirectives(_createVNode(LlSecondaryButton, {
        onBtnClick: _cache[45] || (_cache[45] = $event => undo(true))
      }, {
        default: _withCtx(() => [...(_cache[87] || (_cache[87] = [_createTextVNode(" Undo ", -1)]))]),
        _: 1
      }, 512), [[_vShow, accessItem.value.undo && _unref(totals).amount == 0 && _unref(permissions).billing.create]])], 512), [[_vShow, _unref(state).closed]])]), _createVNode(_component_v_dialog, {
        modelValue: showInvoiceTemplateModal.value,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = $event => showInvoiceTemplateModal.value = $event),
        "max-width": "1400px",
        persistent: ""
      }, {
        default: _withCtx(() => [_createVNode(UpdateInvoiceTemplateModal, {
          "selected-invoice-template": selectedTemplateId.value,
          tracking: __props.tracking,
          state: _unref(state),
          "is-training-flow": _unref(companySettings).demoMode && _unref(features).invoicingDemoMode,
          leanLawAuth: __props.leanLawAuth,
          onCloseDialog: handleCloseInvoiceTemplate,
          onOpenSubscriptionModal: handleOpenSubscriptionModal,
          onCloseDraftModal: handleCloseDraftModal
        }, null, 8, ["selected-invoice-template", "tracking", "state", "is-training-flow", "leanLawAuth"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};